import type { SaleDict } from './sale-i18n';

// Từ điển cho app/sale/page.tsx (khung trang, bộ lọc, danh sách/lịch trống, chat AI, modal chi tiết, review, đặt lịch xem).
export const SALE_DICT: SaleDict = {
  // ── đơn vị giá ──
  'page.unit.night': { vi: '/đêm', en: '/night', zh: '/晚', ko: '/박', fr: '/nuit', ja: '/泊' },
  'page.unit.month': { vi: '/tháng', en: '/month', zh: '/月', ko: '/월', fr: '/mois', ja: '/月' },
  'page.unit.sqmMonth': { vi: '/m²/tháng', en: '/m²/month', zh: '/平方米/月', ko: '/m²/월', fr: '/m²/mois', ja: '/㎡/月' },

  // ── preset khoảng ngày ──
  'page.preset.2w': { vi: '2 tuần', en: '2 weeks', zh: '2周', ko: '2주', fr: '2 semaines', ja: '2週間' },
  'page.preset.1m': { vi: '1 tháng', en: '1 month', zh: '1个月', ko: '1개월', fr: '1 mois', ja: '1ヶ月' },
  'page.preset.3m': { vi: '3 tháng', en: '3 months', zh: '3个月', ko: '3개월', fr: '3 mois', ja: '3ヶ月' },
  'page.preset.6m': { vi: '6 tháng', en: '6 months', zh: '6个月', ko: '6개월', fr: '6 mois', ja: '6ヶ月' },
  'page.preset.12m': { vi: '12 tháng', en: '12 months', zh: '12个月', ko: '12개월', fr: '12 mois', ja: '12ヶ月' },

  // ── header ──
  'page.header.title': { vi: 'Tra cứu phòng trống', en: 'Room availability', zh: '空房查询', ko: '빈 객실 조회', fr: 'Disponibilités des logements', ja: '空室検索' },
  'page.header.subtitle': {
    vi: 'Trang tra cứu cho môi giới — không cần đăng nhập',
    en: 'Lookup page for agents — no login required',
    zh: '中介查询页面——无需登录',
    ko: '중개인용 조회 페이지 — 로그인 불필요',
    fr: 'Page de consultation pour les agents — sans connexion',
    ja: '仲介業者向け検索ページ — ログイン不要',
  },
  'page.header.signOut': { vi: 'Đăng xuất', en: 'Sign out', zh: '退出登录', ko: '로그아웃', fr: 'Se déconnecter', ja: 'ログアウト' },
  'page.header.signIn': {
    vi: 'Đăng nhập để tăng lượt tra cứu',
    en: 'Sign in for more lookups',
    zh: '登录以增加查询次数',
    ko: '로그인하여 조회 횟수 늘리기',
    fr: 'Connectez-vous pour plus de recherches',
    ja: 'ログインして検索回数を増やす',
  },

  // ── quota / trạng thái tải ──
  'page.quota.exhausted': {
    vi: 'Đã dùng hết {max} lượt tra cứu trong <strong>cửa sổ 30 phút</strong> — tự mở lại sau 30 phút, hoặc đăng nhập ngay để có lượt cao hơn.',
    en: 'You have used all {max} lookups in the <strong>30-minute window</strong> — it reopens automatically after 30 minutes, or sign in now for a higher limit.',
    zh: '您在<strong>30分钟窗口</strong>内的 {max} 次查询已用完——30分钟后自动恢复，或立即登录以获得更多次数。',
    ko: '<strong>30분 구간</strong> 동안 조회 {max}회를 모두 사용했습니다 — 30분 후 자동으로 다시 열리며, 지금 로그인하면 더 많은 횟수를 받을 수 있습니다.',
    fr: 'Vous avez utilisé les {max} recherches de la <strong>fenêtre de 30 minutes</strong> — elle se rouvre automatiquement après 30 minutes, ou connectez-vous pour une limite plus élevée.',
    ja: '<strong>30分間</strong>の検索回数 {max} 回をすべて使用しました — 30分後に自動で再開されます。ログインすると、より多くの回数をご利用いただけます。',
  },
  'page.quota.signInGoogle': {
    vi: 'Đăng nhập bằng Google để xem tiếp ngay',
    en: 'Sign in with Google to continue now',
    zh: '用 Google 登录以立即继续',
    ko: 'Google로 로그인하여 바로 계속하기',
    fr: 'Connectez-vous avec Google pour continuer',
    ja: 'Googleでログインしてすぐに続ける',
  },
  'page.quota.warn': {
    vi: 'Bạn đã dùng {used}/{max} lượt tra cứu trong 30 phút.',
    en: 'You have used {used}/{max} lookups in the last 30 minutes.',
    zh: '您在30分钟内已使用 {used}/{max} 次查询。',
    ko: '30분 동안 조회 {used}/{max}회를 사용했습니다.',
    fr: 'Vous avez utilisé {used}/{max} recherches sur 30 minutes.',
    ja: '過去30分間に {used}/{max} 回検索しました。',
  },
  'page.loadError': {
    vi: 'Không tải được dữ liệu. Vui lòng thử lại sau.',
    en: 'Could not load data. Please try again later.',
    zh: '无法加载数据，请稍后重试。',
    ko: '데이터를 불러오지 못했습니다. 나중에 다시 시도해 주세요.',
    fr: 'Impossible de charger les données. Veuillez réessayer plus tard.',
    ja: 'データを読み込めませんでした。しばらくしてからもう一度お試しください。',
  },
  'page.loading': { vi: 'Đang tải...', en: 'Loading...', zh: '加载中...', ko: '불러오는 중...', fr: 'Chargement...', ja: '読み込み中...' },
  'page.empty.catalog': {
    vi: 'Chưa có phòng nào được công khai trên trang này.',
    en: 'No rooms have been published on this page yet.',
    zh: '此页面暂无公开的房源。',
    ko: '이 페이지에 공개된 객실이 아직 없습니다.',
    fr: "Aucun logement n'est encore publié sur cette page.",
    ja: 'このページに公開されているお部屋はまだありません。',
  },

  // ── bộ lọc ──
  'page.filter.area': { vi: 'Khu vực:', en: 'Area:', zh: '区域：', ko: '지역:', fr: 'Secteur :', ja: 'エリア:' },
  'page.filter.all': { vi: 'Tất cả', en: 'All', zh: '全部', ko: '전체', fr: 'Tous', ja: 'すべて' },
  'page.filter.allBuildings': {
    vi: 'Tất cả toà ({n} căn)',
    en: 'All buildings ({n} units)',
    zh: '全部楼栋（{n} 套）',
    ko: '전체 건물 ({n}채)',
    fr: 'Tous les immeubles ({n} logements)',
    ja: 'すべての建物（{n}室）',
  },
  'page.filter.freeBlocked': {
    vi: 'Đã hết lượt tra cứu — chưa kiểm tra được phòng trống',
    en: 'Lookup limit reached — availability cannot be checked yet',
    zh: '查询次数已用完——暂时无法查看空房',
    ko: '조회 횟수를 모두 사용했습니다 — 빈 객실을 아직 확인할 수 없습니다',
    fr: 'Limite de recherches atteinte — disponibilités non vérifiables pour le moment',
    ja: '検索回数の上限に達しました — 空室を確認できません',
  },
  'page.filter.free': { vi: '✓ Còn trống ({n})', en: '✓ Available ({n})', zh: '✓ 有空房 ({n})', ko: '✓ 예약 가능 ({n})', fr: '✓ Disponible ({n})', ja: '✓ 空室あり（{n}）' },
  'page.filter.roomType': { vi: 'Loại phòng:', en: 'Room type:', zh: '房型：', ko: '객실 유형:', fr: 'Type de logement :', ja: 'お部屋タイプ:' },
  'page.filter.bed1': { vi: 'Căn 1 ngủ ({n})', en: '1-bedroom ({n})', zh: '一居室 ({n})', ko: '침실 1개 ({n})', fr: '1 chambre ({n})', ja: '1ベッドルーム（{n}）' },
  'page.filter.bed2': { vi: 'Căn 2 ngủ ({n})', en: '2-bedroom ({n})', zh: '两居室 ({n})', ko: '침실 2개 ({n})', fr: '2 chambres ({n})', ja: '2ベッドルーム（{n}）' },
  'page.filter.duplex': { vi: 'Căn duplex ({n})', en: 'Duplex ({n})', zh: '复式 ({n})', ko: '복층 ({n})', fr: 'Duplex ({n})', ja: 'メゾネット（{n}）' },
  'page.filter.office': { vi: 'Văn phòng ({n})', en: 'Office ({n})', zh: '办公室 ({n})', ko: '사무실 ({n})', fr: 'Bureau ({n})', ja: 'オフィス（{n}）' },

  // ── chọn ngày ──
  'page.date.viewFrom': { vi: 'Xem trống từ', en: 'Check availability from', zh: '查看空房起始日', ko: '빈 객실 조회 시작일', fr: 'Disponibilités à partir du', ja: '空室を表示する開始日' },
  'page.date.prevWeek': { vi: 'Lùi 1 tuần', en: 'Back 1 week', zh: '前一周', ko: '1주 전', fr: 'Semaine précédente', ja: '1週間戻る' },
  'page.date.nextWeek': { vi: 'Tới 1 tuần', en: 'Forward 1 week', zh: '后一周', ko: '1주 후', fr: 'Semaine suivante', ja: '1週間進む' },
  'page.date.today': { vi: 'Hôm nay', en: 'Today', zh: '今天', ko: '오늘', fr: "Aujourd'hui", ja: '今日' },
  'page.date.within': { vi: 'trong', en: 'for', zh: '为期', ko: '기간', fr: 'pour', ja: '期間' },
  'page.date.custom': { vi: 'Tuỳ chỉnh', en: 'Custom', zh: '自定义', ko: '직접 설정', fr: 'Personnalisé', ja: 'カスタム' },
  'page.date.until': { vi: 'đến', en: 'to', zh: '至', ko: '~', fr: 'au', ja: 'から' },
  'page.view.gallery': { vi: '🖼 Danh sách phòng', en: '🖼 Room list', zh: '🖼 房源列表', ko: '🖼 객실 목록', fr: '🖼 Liste des logements', ja: '🖼 お部屋一覧' },
  'page.view.timeline': { vi: '⌗ Lịch trống theo ngày', en: '⌗ Daily availability', zh: '⌗ 每日空房日历', ko: '⌗ 일별 빈 객실 달력', fr: '⌗ Disponibilités par jour', ja: '⌗ 日別の空室カレンダー' },

  // ── lịch trống (timeline) ──
  'page.tl.loading': { vi: 'Đang tải lịch trống...', en: 'Loading availability...', zh: '正在加载空房日历...', ko: '빈 객실 달력을 불러오는 중...', fr: 'Chargement des disponibilités...', ja: '空室状況を読み込み中...' },
  'page.tl.room': { vi: 'Phòng', en: 'Room', zh: '房间', ko: '객실', fr: 'Logement', ja: 'お部屋' },
  'page.tl.loadingBadge': { vi: 'Đang tải…', en: 'Loading…', zh: '加载中…', ko: '불러오는 중…', fr: 'Chargement…', ja: '読み込み中…' },
  'page.tl.allFree': { vi: 'Trống hết', en: 'All free', zh: '全部空闲', ko: '전체 비어 있음', fr: 'Tout libre', ja: 'すべて空室' },
  'page.tl.cellBooked': { vi: 'Đã có khách', en: 'Booked', zh: '已有客人', ko: '예약됨', fr: 'Occupé', ja: '予約済み' },
  'page.tl.cellFree': { vi: 'Trống', en: 'Available', zh: '空闲', ko: '비어 있음', fr: 'Libre', ja: '空室' },
  'page.tl.legend': {
    vi: 'Ô đỏ = đã có khách, ô xanh = còn trống. Bấm vào tên phòng để xem ảnh/tiện ích chi tiết.',
    en: 'Red = booked, green = available. Tap a room name to see photos and amenities.',
    zh: '红色 = 已有客人，绿色 = 空闲。点击房间名称查看照片和设施详情。',
    ko: '빨간색 = 예약됨, 초록색 = 비어 있음. 객실 이름을 누르면 사진과 편의시설을 볼 수 있습니다.',
    fr: 'Rouge = occupé, vert = libre. Touchez le nom du logement pour voir les photos et les équipements.',
    ja: '赤 = 予約済み、緑 = 空室。お部屋名をタップすると、写真や設備の詳細をご覧いただけます。',
  },

  // ── danh sách phòng (gallery) ──
  'page.gallery.count': { vi: 'căn', en: 'units', zh: '套', ko: '채', fr: 'logements', ja: '室' },
  'page.gallery.freeAcross': {
    vi: 'còn trống suốt khoảng đã chọn',
    en: 'available for the whole selected period',
    zh: '在所选时间段内全程有空',
    ko: '선택한 기간 내내 예약 가능',
    fr: 'disponibles sur toute la période choisie',
    ja: '選択した期間中ずっと空室',
  },
  'page.gallery.office': { vi: 'Văn phòng', en: 'Office', zh: '办公室', ko: '사무실', fr: 'Bureau', ja: 'オフィス' },
  'page.gallery.free': { vi: 'Còn trống', en: 'Available', zh: '有空房', ko: '예약 가능', fr: 'Disponible', ja: '空室' },
  'page.gallery.booked': { vi: 'Đã có khách', en: 'Booked', zh: '已有客人', ko: '예약됨', fr: 'Occupé', ja: '予約済み' },
  'page.gallery.guests': { vi: '{n} khách', en: '{n} guests', zh: '{n} 位客人', ko: '{n}명', fr: '{n} voyageurs', ja: '{n}名' },
  'page.gallery.refPrice': { vi: ' · giá tham khảo', en: ' · reference price', zh: ' · 参考价', ko: ' · 참고 가격', fr: ' · prix indicatif', ja: ' · 参考価格' },
  'page.gallery.updating': {
    vi: 'Đang cập nhật tình trạng trống...',
    en: 'Updating availability...',
    zh: '正在更新空房状态...',
    ko: '빈 객실 현황을 업데이트하는 중...',
    fr: 'Mise à jour des disponibilités...',
    ja: '空室状況を更新中...',
  },
  'page.gallery.noMatch': {
    vi: 'Không có căn nào khớp bộ lọc.',
    en: 'No units match the filters.',
    zh: '没有符合筛选条件的房源。',
    ko: '필터에 맞는 객실이 없습니다.',
    fr: 'Aucun logement ne correspond aux filtres.',
    ja: '条件に一致するお部屋がありません。',
  },

  // ── chat AI ──
  'page.chat.sample1': {
    vi: 'Có phòng 2 ngủ nào đang trống không?',
    en: 'Are any 2-bedroom units available?',
    zh: '有空着的两居室吗？',
    ko: '비어 있는 침실 2개짜리 객실이 있나요?',
    fr: 'Y a-t-il un logement 2 chambres disponible ?',
    ja: '空いている2ベッドルームはありますか？',
  },
  'page.chat.sample2': {
    vi: 'Còn phòng nào trống khoảng 15/9 không?',
    en: 'Is anything available around 15 Sept?',
    zh: '9月15日前后还有空房吗？',
    ko: '9월 15일경에 비어 있는 객실이 있나요?',
    fr: 'Reste-t-il un logement disponible vers le 15 septembre ?',
    ja: '9月15日頃に空いているお部屋はありますか？',
  },
  'page.chat.sample3': {
    vi: 'Phòng có ban công, view đẹp không?',
    en: 'Which rooms have a balcony or a nice view?',
    zh: '哪些房间有阳台或好看的景观？',
    ko: '발코니나 좋은 전망이 있는 객실이 있나요?',
    fr: 'Quels logements ont un balcon ou une belle vue ?',
    ja: 'バルコニーや眺めの良いお部屋はどれですか？',
  },
  'page.chat.sample4': {
    vi: 'Căn nào có bếp riêng?',
    en: 'Which units have a private kitchen?',
    zh: '哪些房源有独立厨房？',
    ko: '독립 주방이 있는 객실은 어디인가요?',
    fr: 'Quels logements ont une cuisine privée ?',
    ja: '専用キッチン付きのお部屋はどれですか？',
  },
  'page.chat.limit': {
    vi: 'Đã hết lượt hỏi trong cửa sổ 30 phút — tải lại trang sau 30 phút để hỏi tiếp, hoặc liên hệ trực tiếp để được hỗ trợ ngay.',
    en: 'You have used all your questions in the 30-minute window — reload the page after 30 minutes to ask more, or contact us directly for immediate help.',
    zh: '30分钟内的提问次数已用完——请在30分钟后刷新页面继续提问，或直接联系我们获取即时帮助。',
    ko: '30분 구간의 질문 횟수를 모두 사용했습니다 — 30분 후 페이지를 새로고침하여 계속 질문하시거나, 바로 연락하여 도움을 받으세요.',
    fr: 'Vous avez utilisé toutes vos questions de la fenêtre de 30 minutes — rechargez la page après 30 minutes pour en poser d\'autres, ou contactez-nous directement pour une aide immédiate.',
    ja: '30分間の質問回数をすべて使用しました — 30分後にページを再読み込みして続けるか、お急ぎの場合は直接お問い合わせください。',
  },
  'page.chat.error': { vi: 'Có lỗi xảy ra, thử lại sau.', en: 'Something went wrong, please try again later.', zh: '出错了，请稍后重试。', ko: '오류가 발생했습니다. 나중에 다시 시도해 주세요.', fr: 'Une erreur est survenue, veuillez réessayer plus tard.', ja: 'エラーが発生しました。しばらくしてからもう一度お試しください。' },
  'page.chat.offline': { vi: 'Mất kết nối, thử lại sau.', en: 'Connection lost, please try again later.', zh: '连接中断，请稍后重试。', ko: '연결이 끊겼습니다. 나중에 다시 시도해 주세요.', fr: 'Connexion perdue, veuillez réessayer plus tard.', ja: '接続が切れました。しばらくしてからもう一度お試しください。' },
  'page.chat.title': { vi: 'Hỏi AI', en: 'Ask AI', zh: '询问 AI', ko: 'AI에게 질문', fr: "Demander à l'IA", ja: 'AIに質問' },
  'page.chat.zalo': {
    vi: 'Cần hỗ trợ thêm? Chat Zalo với quản lý',
    en: 'Need more help? Chat with the manager on Zalo',
    zh: '需要更多帮助？通过 Zalo 联系经理',
    ko: '도움이 더 필요하신가요? Zalo로 매니저와 채팅하세요',
    fr: "Besoin d'aide ? Discutez avec le gestionnaire sur Zalo",
    ja: 'さらにサポートが必要ですか？Zaloでマネージャーにチャットで相談',
  },
  'page.chat.intro': {
    vi: 'Hỏi về tiện ích, mô tả căn, hoặc tìm căn trống theo ngày — thử bấm câu mẫu bên dưới:',
    en: 'Ask about amenities, unit descriptions, or find available units by date — try a sample question below:',
    zh: '可询问设施、房源介绍，或按日期查找空房——试试下面的示例问题：',
    ko: '편의시설, 객실 설명을 묻거나 날짜별 빈 객실을 찾아보세요 — 아래 예시 질문을 눌러보세요:',
    fr: 'Posez vos questions sur les équipements, la description des logements ou les disponibilités par date — essayez un exemple ci-dessous :',
    ja: '設備やお部屋の説明について質問したり、日付から空室を探したりできます — 下のサンプル質問をお試しください:',
  },
  'page.chat.view': { vi: 'Xem {code} →', en: 'View {code} →', zh: '查看 {code} →', ko: '{code} 보기 →', fr: 'Voir {code} →', ja: '{code} を見る →' },
  'page.chat.answering': { vi: 'Đang trả lời...', en: 'Answering...', zh: '正在回复...', ko: '답변 중...', fr: 'Réponse en cours...', ja: '回答中...' },
  'page.chat.placeholder': { vi: 'Nhập câu hỏi...', en: 'Type your question...', zh: '输入您的问题...', ko: '질문을 입력하세요...', fr: 'Saisissez votre question...', ja: '質問を入力...' },
  'page.chat.send': { vi: 'Gửi', en: 'Send', zh: '发送', ko: '보내기', fr: 'Envoyer', ja: '送信' },

  // ── modal chi tiết ──
  'page.detail.copied': {
    vi: 'Đã copy link — dán vào Zalo/nhóm chat để chia sẻ',
    en: 'Link copied — paste it into Zalo or a chat group to share',
    zh: '链接已复制——粘贴到 Zalo 或聊天群即可分享',
    ko: '링크를 복사했습니다 — Zalo나 채팅방에 붙여넣어 공유하세요',
    fr: 'Lien copié — collez-le dans Zalo ou un groupe de discussion pour le partager',
    ja: 'リンクをコピーしました — Zaloやチャットグループに貼り付けて共有してください',
  },
  'page.detail.copyFail': { vi: 'Không copy được, thử lại', en: 'Could not copy, please try again', zh: '复制失败，请重试', ko: '복사하지 못했습니다. 다시 시도해 주세요', fr: 'Copie impossible, veuillez réessayer', ja: 'コピーできませんでした。もう一度お試しください' },
  'page.detail.needSale': {
    vi: 'Chưa thể tải ảnh — cần đăng nhập tài khoản Sale đã được Admin phê duyệt. Liên hệ Admin 0913552222 để được cấp quyền.',
    en: 'Cannot download the photo — you need to sign in with a Sale account approved by the Admin. Contact the Admin at 0913552222 to get access.',
    zh: '暂时无法下载照片——需要登录已获管理员批准的销售账号。请联系管理员 0913552222 申请权限。',
    ko: '사진을 다운로드할 수 없습니다 — 관리자가 승인한 Sale 계정으로 로그인해야 합니다. 권한이 필요하면 관리자 0913552222로 연락하세요.',
    fr: "Téléchargement impossible — connectez-vous avec un compte Sale approuvé par l'administrateur. Contactez l'administrateur au 0913552222 pour obtenir l'accès.",
    ja: '写真をダウンロードできません — 管理者に承認されたSaleアカウントでのログインが必要です。権限の付与は管理者（0913552222）までお問い合わせください。',
  },
  'page.detail.dlFail': { vi: 'Không tải được ảnh', en: 'Could not download the photo', zh: '无法下载照片', ko: '사진을 다운로드하지 못했습니다', fr: 'Impossible de télécharger la photo', ja: '写真をダウンロードできませんでした' },
  'page.detail.dlFailNet': {
    vi: 'Không tải được ảnh — mất mạng hoặc hệ thống lỗi. Thử lại sau.',
    en: 'Could not download the photo — network or system error. Please try again later.',
    zh: '无法下载照片——网络中断或系统错误，请稍后重试。',
    ko: '사진을 다운로드하지 못했습니다 — 네트워크 또는 시스템 오류입니다. 나중에 다시 시도해 주세요.',
    fr: 'Impossible de télécharger la photo — erreur réseau ou système. Veuillez réessayer plus tard.',
    ja: '写真をダウンロードできませんでした — ネットワークまたはシステムのエラーです。しばらくしてからもう一度お試しください。',
  },
  'page.detail.loadError': { vi: 'Không tải được thông tin phòng.', en: 'Could not load room information.', zh: '无法加载房间信息。', ko: '객실 정보를 불러오지 못했습니다.', fr: 'Impossible de charger les informations du logement.', ja: 'お部屋の情報を読み込めませんでした。' },
  'page.detail.title': { vi: 'Phòng {number} — {building}', en: 'Room {number} — {building}', zh: '{number} 房 — {building}', ko: '{number}호 — {building}', fr: 'Logement {number} — {building}', ja: '{number}号室 — {building}' },
  'page.detail.copyTip': { vi: 'Copy link chia sẻ căn này', en: 'Copy a link to share this unit', zh: '复制此房源的分享链接', ko: '이 객실 공유 링크 복사', fr: 'Copier le lien de ce logement', ja: 'このお部屋を共有するリンクをコピー' },
  'page.detail.share': { vi: '🔗 Chia sẻ', en: '🔗 Share', zh: '🔗 分享', ko: '🔗 공유', fr: '🔗 Partager', ja: '🔗 共有' },
  'page.detail.salePriceLabel': { vi: 'giá tham khảo cho Sale', en: 'reference price for Sales', zh: '销售参考价', ko: 'Sale 참고 가격', fr: 'prix indicatif pour les agents', ja: 'Sales向け参考価格' },
  'page.detail.mediaCount': { vi: '{n} ảnh/clip — bấm để xem to', en: '{n} photos/clips — tap to enlarge', zh: '{n} 张照片/视频——点击放大', ko: '사진/영상 {n}개 — 눌러서 크게 보기', fr: '{n} photos/vidéos — touchez pour agrandir', ja: '写真/動画 {n}件 — タップして拡大' },
  'page.detail.close': { vi: 'Đóng', en: 'Close', zh: '关闭', ko: '닫기', fr: 'Fermer', ja: '閉じる' },
  'page.detail.dlTip': {
    vi: 'Tải ảnh gốc (cần tài khoản Sale đã được Admin phê duyệt)',
    en: 'Download the original photo (requires a Sale account approved by the Admin)',
    zh: '下载原图（需要已获管理员批准的销售账号）',
    ko: '원본 사진 다운로드 (관리자가 승인한 Sale 계정 필요)',
    fr: "Télécharger la photo originale (compte Sale approuvé par l'administrateur requis)",
    ja: 'オリジナル写真をダウンロード（管理者に承認されたSaleアカウントが必要です）',
  },
  'page.detail.downloading': { vi: 'Đang tải...', en: 'Downloading...', zh: '下载中...', ko: '다운로드 중...', fr: 'Téléchargement...', ja: 'ダウンロード中...' },
  'page.detail.download': { vi: '⬇ Tải ảnh', en: '⬇ Download', zh: '⬇ 下载照片', ko: '⬇ 사진 저장', fr: '⬇ Télécharger', ja: '⬇ ダウンロード' },

  // ── nhóm tiện ích ──
  'page.amenity.collapse': { vi: 'Thu gọn', en: 'Show less', zh: '收起', ko: '접기', fr: 'Réduire', ja: '閉じる' },
  'page.amenity.more': { vi: 'Xem thêm (+{n})', en: 'Show more (+{n})', zh: '展开 (+{n})', ko: '더 보기 (+{n})', fr: 'Voir plus (+{n})', ja: 'もっと見る（+{n}）' },

  // ── review ──
  'page.review.title': {
    vi: '⭐ {n} đánh giá 5 sao từ khách đã lưu trú',
    en: '⭐ {n} five-star reviews from past guests',
    zh: '⭐ 来自住客的 {n} 条五星好评',
    ko: '⭐ 투숙객의 5성 후기 {n}개',
    fr: '⭐ {n} avis 5 étoiles de voyageurs',
    ja: '⭐ 過去のお客様からの5つ星レビュー {n}件',
  },
  'page.review.countries': {
    vi: 'Khách đến từ <b>{n} quốc gia</b>:',
    en: 'Guests from <b>{n} countries</b>:',
    zh: '住客来自 <b>{n} 个国家</b>：',
    ko: '<b>{n}개국</b>에서 온 투숙객:',
    fr: 'Voyageurs de <b>{n} pays</b> :',
    ja: '<b>{n}か国</b>からのお客様:',
  },
  'page.review.countryTip': { vi: '{name} — {count} đánh giá', en: '{name} — {count} reviews', zh: '{name} — {count} 条评价', ko: '{name} — 후기 {count}개', fr: '{name} — {count} avis', ja: '{name} — レビュー{count}件' },
  'page.review.praise': { vi: 'Khách thường khen', en: 'Guests often praise', zh: '住客常夸', ko: '투숙객이 자주 칭찬하는 점', fr: 'Ce que les voyageurs apprécient', ja: 'お客様からよく褒められる点' },
  'page.review.hideOrig': { vi: 'Ẩn bản gốc', en: 'Hide original', zh: '隐藏原文', ko: '원문 숨기기', fr: "Masquer l'original", ja: '原文を隠す' },
  'page.review.showOrig': { vi: 'Xem bản gốc', en: 'Show original', zh: '查看原文', ko: '원문 보기', fr: "Voir l'original", ja: '原文を表示' },
  'page.review.collapse': { vi: 'Thu gọn', en: 'Show less', zh: '收起', ko: '접기', fr: 'Réduire', ja: '閉じる' },
  'page.review.showAll': { vi: 'Xem tất cả {n} đánh giá', en: 'See all {n} reviews', zh: '查看全部 {n} 条评价', ko: '후기 {n}개 모두 보기', fr: 'Voir les {n} avis', ja: 'レビュー全{n}件を見る' },

  // ── đặt lịch xem căn ──
  'page.viewing.done': {
    vi: 'Đã gửi lịch xem căn — chờ chủ nhà xác nhận.',
    en: 'Viewing request sent — awaiting the owner\'s confirmation.',
    zh: '看房申请已发送——等待房东确认。',
    ko: '방문 요청을 보냈습니다 — 집주인의 확인을 기다리는 중입니다.',
    fr: 'Demande de visite envoyée — en attente de confirmation du propriétaire.',
    ja: '内見のご希望を送信しました — オーナーの確認をお待ちください。',
  },
  'page.viewing.open': { vi: 'Đặt lịch xem căn', en: 'Schedule a viewing', zh: '预约看房', ko: '방문 일정 예약', fr: 'Planifier une visite', ja: '内見を予約する' },
  'page.viewing.needFields': { vi: 'Nhập đủ tên và số điện thoại', en: 'Please enter both name and phone number', zh: '请填写姓名和电话号码', ko: '이름과 전화번호를 모두 입력해 주세요', fr: 'Veuillez saisir le nom et le numéro de téléphone', ja: 'お名前と電話番号の両方を入力してください' },
  'page.viewing.badPhone': { vi: 'Số điện thoại không hợp lệ', en: 'Invalid phone number', zh: '电话号码无效', ko: '전화번호가 올바르지 않습니다', fr: 'Numéro de téléphone invalide', ja: '電話番号が正しくありません' },
  'page.viewing.sendFail': { vi: 'Không gửi được, thử lại sau', en: 'Could not send, please try again later', zh: '发送失败，请稍后重试', ko: '전송하지 못했습니다. 나중에 다시 시도해 주세요', fr: "Envoi impossible, veuillez réessayer plus tard", ja: '送信できませんでした。しばらくしてからもう一度お試しください' },
  'page.viewing.sendFailNet': {
    vi: 'Không gửi được yêu cầu — mất mạng hoặc hệ thống lỗi. Thử lại sau.',
    en: 'Could not send the request — network or system error. Please try again later.',
    zh: '无法发送申请——网络中断或系统错误，请稍后重试。',
    ko: '요청을 보내지 못했습니다 — 네트워크 또는 시스템 오류입니다. 나중에 다시 시도해 주세요.',
    fr: "Impossible d'envoyer la demande — erreur réseau ou système. Veuillez réessayer plus tard.",
    ja: 'リクエストを送信できませんでした — ネットワークまたはシステムのエラーです。しばらくしてからもう一度お試しください。',
  },
  'page.viewing.prefilled': {
    vi: 'Đã điền sẵn từ thông tin bạn nhập trước đó — sửa nếu chưa đúng.',
    en: 'Pre-filled from details you entered earlier — edit if incorrect.',
    zh: '已根据您之前填写的信息自动填入——如有误请修改。',
    ko: '이전에 입력하신 정보로 미리 채웠습니다 — 틀리면 수정해 주세요.',
    fr: 'Pré-rempli avec les informations saisies précédemment — modifiez-les si nécessaire.',
    ja: '以前に入力した内容を自動入力しています — 誤りがあれば修正してください。',
  },
  'page.viewing.namePh': { vi: 'Tên Sale/liên hệ', en: 'Sales / contact name', zh: '销售/联系人姓名', ko: 'Sale/연락처 이름', fr: 'Nom de l\'agent / du contact', ja: 'Sales／ご担当者名' },
  'page.viewing.phonePh': { vi: 'Số điện thoại', en: 'Phone number', zh: '电话号码', ko: '전화번호', fr: 'Numéro de téléphone', ja: '電話番号' },
  'page.viewing.cancel': { vi: 'Huỷ', en: 'Cancel', zh: '取消', ko: '취소', fr: 'Annuler', ja: 'キャンセル' },
  'page.viewing.sending': { vi: 'Đang gửi...', en: 'Sending...', zh: '发送中...', ko: '전송 중...', fr: 'Envoi...', ja: '送信中...' },
  'page.viewing.send': { vi: 'Gửi yêu cầu', en: 'Send request', zh: '发送申请', ko: '요청 보내기', fr: 'Envoyer la demande', ja: 'リクエストを送信' },
};
